// services/categoryApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCookie } from 'libraries/cookie'

export const categoryApiTree = createApi({
  reducerPath: 'categoryTreeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.config.API_URL,
    prepareHeaders: headers => {
      const storeId = window.config.STORE_ID?.toString() || ''
      if (storeId) {
        headers.set('X-BSTORE-ID', storeId)
      }
      const token = getCookie('token')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
  }),
  endpoints: builder => ({
    fetchCategoryTree: builder.query<any, string | void>({
      query: search => (search ? `v1/categories/search?search=${search}` : 'v1/categories/tree'),
    }),
  }),
})

export const { useFetchCategoryTreeQuery } = categoryApiTree
